import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "t2-footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "to_foot_link" }
const _hoisted_4 = ["value", "onClick"]
const _hoisted_5 = ["value", "onClick"]
const _hoisted_6 = ["value", "onClick"]
const _hoisted_7 = { class: "t2_footer_bottom" }
const _hoisted_8 = { class: "t2_footer_r" }
const _hoisted_9 = { style: {"cursor":"pointer"} }

import { reactive } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const data = reactive({
  list1: [] as any,
  list2: [] as any,
  list3: [] as any,
}) as any

data.list1 = [
  {name: '海事局', url: 'http://www.msa.gov.cn/'},
  {name: '发改委', url: 'https://www.ndrc.gov.cn/'},
  {name: '商务部', url: 'http://www.mofcom.gov.cn/'},
  {name: '检察院', url: 'http://www.spp.gov.cn/'},
  {name: '外汇局', url: 'http://www.safe.gov.cn/'},
]
data.list2 = [
  {name: '中国（河南）自由贸易试验区郑州片区', url: 'https://zzftz.zhengzhou.gov.cn/'},
  {name: '中国（河南）自由贸易试验区洛阳片区', url: 'https://www.lhdz.gov.cn/sy/lypq/'},
  {name: '中国（天津）自由贸易试验区', url: 'http://www.china-tjftz.gov.cn/'},
  /*{name: '中国（四川）自由贸易试验区', url: 'http://ftz.sc.gov.cn/'},*/
  {name: '中国（浙江）自由贸易试验区', url: 'https://ftz.zj.gov.cn/'},
]
data.list3 = [
  // {name: '开封市经开区', url: 'http://221.176.156.132:8081'},
  {name: '开封市农林局', url: 'http://nyncj.kaifeng.gov.cn/'},
  {name: '开封市科技局', url: 'https://kjj.kaifeng.gov.cn/'},
  {name: '开封市商务局', url: 'http://swj.kaifeng.gov.cn/'},
  {name: '开封市工商行政管理局', url: 'http://scjg.kaifeng.gov.cn/'},
  {name: '开封市人力资源和社会保障局', url: 'http://rsj.kaifeng.gov.cn/'},
  /*{name: '开封市经济开发区', url: 'http://221.176.156.132:8081/'},*/
]

const goHref = (url:string) => {
  if(url){
    window.open(url,'_blank')
  }
}
const baJump = () => {
    window.open("https://beian.miit.gov.cn/#/Integrated/index",'_blank')
}
const ygwabh = () => {
    window.open("https://beian.mps.gov.cn/#/query/websearch?code=41021102000190",'_blank')
}
const goUrl = (num:number) => {
  let obj = document.getElementById(`select${num}`) as any
  let index = obj.selectedIndex
  if(index > 0){
    let url = data[`list${num}`][index - 1].url
    goHref(url)
  }

}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("select", {
          id: "select1",
          onChange: _cache[0] || (_cache[0] = ($event: any) => (goUrl(1)))
        }, [
          _cache[5] || (_cache[5] = _createElementVNode("option", null, "国家部委", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list1, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              value: item.url,
              key: item.url,
              onClick: ($event: any) => (goHref(item.url))
            }, _toDisplayString(item.name), 9, _hoisted_4))
          }), 128))
        ], 32),
        _createElementVNode("select", {
          id: "select2",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (goUrl(2)))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("option", null, "其他自贸区", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list2, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              value: item.url,
              key: item.url,
              onClick: ($event: any) => (goHref(item.url))
            }, _toDisplayString(item.name), 9, _hoisted_5))
          }), 128))
        ], 32),
        _createElementVNode("select", {
          id: "select3",
          onChange: _cache[2] || (_cache[2] = ($event: any) => (goUrl(3)))
        }, [
          _cache[7] || (_cache[7] = _createElementVNode("option", null, "开封市部门", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list3, (item) => {
            return (_openBlock(), _createElementBlock("option", {
              value: item.url,
              key: item.url,
              onClick: ($event: any) => (goHref(item.url))
            }, _toDisplayString(item.name), 9, _hoisted_6))
          }), 128))
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"t2_footer_l\"><div style=\"float:left;width:150px;\"><img src=\"/images/app.png\" style=\"float:left;width:150px;\"><div style=\"line-height:40px;text-align:center;color:#fff;font-size:15px;\">APP下载</div></div><img src=\"/images/gzh.png\" style=\"float:left;margin-left:30px;\"><div style=\"float:left;width:150px;\"><img src=\"/images/xcxm.png\" style=\"width:150px;\"><div style=\"line-height:40px;text-align:center;color:#fff;font-size:15px;\">微信预约小程序</div></div></div>", 1)),
        _createElementVNode("div", _hoisted_8, [
          _cache[10] || (_cache[10] = _createElementVNode("p", null, "Copyright 2016 All Rights Reserved 版权所有，未经授权，禁止转载", -1)),
          _createElementVNode("p", _hoisted_9, [
            _createElementVNode("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (baJump()))
            }, "豫ICP备18006093号-2 "),
            _cache[8] || (_cache[8] = _createTextVNode("        ", -1)),
            _cache[9] || (_cache[9] = _createElementVNode("img", {
              src: "/images/dh.png",
              style: {"width":"25px","height":"25px","margin":"0px 5px","top":"5px","position":"relative"}
            }, null, -1)),
            _createElementVNode("span", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (ygwabh()))
            }, "豫公网安备41021102000190号")
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("p", null, "中国（河南）自由贸易试验区开封片区", -1)),
          _cache[12] || (_cache[12] = _createElementVNode("p", null, "地址：开封郑开大道与十二大街交汇处 电话：0371-22730001 传真：0371-22730008", -1)),
          _cache[13] || (_cache[13] = _createElementVNode("p", null, "技术支持：深圳太极数智技术有限公司", -1))
        ])
      ]),
      _cache[15] || (_cache[15] = _createElementVNode("a", {
        href: "https://bszs.conac.cn/sitename?method=show&id=1CB740D88BBF9C29E06310291AACE3F1",
        target: "_blank",
        onclick: "return confirm('是否跳转其他网址？')"
      }, [
        _createElementVNode("img", {
          src: "/images/btm_img1.png",
          class: "btm_img1"
        })
      ], -1)),
      _cache[16] || (_cache[16] = _createElementVNode("a", {
        href: "https://zfwzgl.www.gov.cn/exposure/jiucuo.html?site_code=4102000052&url=https%3A%2F%2Fftz.kaifeng.gov.cn%2F",
        target: "_blank"
      }, [
        _createElementVNode("img", {
          src: "/images/btm_img2.png",
          class: "btm_img2"
        })
      ], -1))
    ])
  ]))
}
}

})